export default {
    about_management: 'Boshqarma haqida',
    ppp_objects: 'DXSh obyektlari',
    realized_objects: 'Amalga oshirilgan loyihalar',
    private_schools: 'Xususiy maktablar',
    notfound:'Faol lotlar yo\'q',
    faq: 'FAQ',
    contact_us: 'Biz bilan bog\'laning',
    search: 'Qidiruv',
    ministry: 'O\'zbekiston Respublikasi Maktabgacha va maktab ta\'limi vazirligi',
    ministry_footer: 'O\'zbekiston Respublikasi Maktabgacha va maktab ta\'limi vazirligi',
    department: 'Maktablarning istiqbolli modellari va davlat-xususiy sheriklik boshqarmasi',
    active: 'Aktiv',
    active_1: 'Aktiv',
    offered: 'Taklif etiladi',
    proposed_1: 'Taklif etiladi',
    select_district: 'Tumanlarni tanlang',
    select_category: 'Kategoriyalarni tanlang',
    select_type: 'Turlarni tanlang',
    select_region: 'Viloyatni tanlang',
    date_from: 'Dan',
    date_to: 'Gacha',
    more_info: 'Batafsil',
    expDate: 'Tugash muddati',
    faqfull: 'Ko\'p so\'raladigan savollar',
    read: 'O\'qish',
    news: 'Yangiliklar',
    count: 'soni',
    active_objects: 'Aktiv obyektlar',
    site_map: 'Sayt xaritasi',
    webeonmark: 'Saytni ishladi',
    main_page: 'Asosiy',
    your_fullname: 'To\'liq ismingiz',
    name: 'Ism',
    lastname: 'Familiya',
    organization: 'Tashkilot',
    code: 'Kod',
    your_phone: 'Telefon raqamingiz',
    your_email: 'e-pochtangiz',
    message: 'Xabaringiz',
    send: 'Jo\'natish',
    close: 'Yopish',
    city_title: 'DXSh obyektlari',
    school: 'Maktab №',
    contacts: 'Murojaat uchun',
    phone: 'Telefon',
    address: 'Manzil',
    full_address: '100187, Tоshkent shahar, Shayxontohur tumani,Alisher Navoiy ko\'chasi, 2A',
    email: 'E-pochta',
    website: 'Veb sayt',
    working_time: 'Boshqarmaning ish tartibi',
    monday: 'Du',
    tuesday: 'Se',
    wednesday: 'Ch',
    thursday: 'Pa',
    friday: 'Ju',
    saturday: 'Sh',
    sunday: 'Ya',
    aboutfull_1: 'Maktablarning istiqbolli modellari va davlat-xususiy sheriklik boshqarmasining faoliyati xalq ta\'limi sohasida DXSh investitsiya loyihalarini tadqiq etish va amalga oshirishga qaratilgan. Biz loyihalarni har tomonlama qo\'llab-quvvatlaymiz va ularning amalga oshirilishini osonlashtiramiz. Bazani shakllantirish va loyihani amalga oshirishda yordam berish bizning ishimizning muhim qismi hisoblanadi.',
    aboutfull_2: ' Biz qonun chiqaruvchi va ijro etuvchi hokimiyat organlari, mahalliy kompaniyalar, xalqaro va jamoat tashkilotlari bilan samarali hamkorlik qilamiz. Boshqarmaning asosiy maqsadi - davlat va biznes o\'rtasidagi sherikchilik uchun shart-sharoitlar yaratish, DXSh loyihalarini amalga oshirish uchun ularning potentsialini ishlab chiqish va birlashtirish hamda mamlakat iqtisodiyotiga xususiy investitsiyalar hajmini oshirish.',
    city: 'Shahar/viloyat',
    district: 'Tuman',
    legal_address: 'Obyektning yuridik manzili',
    total_area: 'Umumiy maydoni, kv.m',
    building_area: 'Bino ostidagi yer maydoni, sq.m',
    used_area: 'Ishlatilgan maydon, sq.m',
    free_land_area: 'Bo\'sh yer maydoni, sq.m',
    problems: 'Obyektdagi mavjud muammolar',
    status: 'Status',
    language_of_instruction: 'O\'qitish tili',
    opening_date: 'Ochilish sanasi',
    established: 'Ta\'sis etilgan sana',
    admission_terms: 'Qabul shartlari',
    training_duration: 'O\'qish davomiyligi',
    training_duration_1: 'O\'qish davomiyligi',
    language_learning: 'O\'qitish tili',
    specialization: 'Ixtisoslik',
    local_teachers: 'Mahalliy o\'qituvchilar',
    foreign_teachers: 'Xorijiy teachers',
    sport_ground: 'Sport maydoni',
    security: 'Xavfsizlik',
    transport: 'Transport (avtobus)',
    school_hallmark: 'Maktabning o\'ziga xos belgisi',
    payment_for_month: 'Bir oylik o\'quv uchun to\'lov',
    discount: 'Chegirma',
    schoolbook: 'O\'quv qurollari bilan ta\'minlash',
    food: 'Ovqatlanish',
    extraClasses: 'Darsdan tashqari to\'garaklar',
    contact_number: 'Telefon raqam',
    status_0: 'mavjud emas',
    status_1: 'Mavjud',
    titleProblem: 'Tavsif',
    successful_message: 'Rahmat, xabaringiz Moderatorga ko‘rib chiqish uchun yuborildi. Yaqin fursatlarda Siz bilan bog‘lanamiz. ',
    messages: 'Habar',
    andijan: 'Andijon',
    bukhara: 'Buxoro',
    ferghana: 'Farg\'ona',
    Jizzakh: 'Jizzax',
    Namangan: 'Namangan',
    Navai: 'Navoiy',
    Kashkadarya: 'Qashqadaryo',
    Karakalpakstan: 'Qoraqalpog\'iston Respublikasi',
    Samarqand: 'Samarqand',
    Syrdarya: 'Sirdaryo',
    Surkhandarya: 'Surxondaryo',
    Tashkent_reg: 'Toshkent viloyati',
    Tashkent_city: 'Toshkent shahar',
    Khorezm: 'Xorazm',
    about1: "Sifatli ta'lim",
    about11: "Bilimlar iqtisodiyoti yo'lida olg'a siljish uchun sifatli ta'limning ahamiyati davlat va biznes o'rtasida integratsiya va ijtimoiy hamkorlik amalga oshiriladigan milliy innovatsion tizimni shakllantirish uchun shart-sharoitlarni ta'minlashni talab qiladi.",
    about2: "Maktablarni rekonstruksiya qilish",
    about21:'Qayta qurish ko\'pincha maktab joylashgan hududning ijtimoiy-estetik, pedagogik, texnologik, demografik jihatlarini o\'z ichiga olgan kontseptual asosni yaratish yoki yangilashni o\'z ichiga oladi.',
    about3:"Investorlarni jalb qilish",
    about31:'DXSh mexanizmlari davlat organlari va tadbirkorlik subyektlari o\'rtasida uzoq muddatli asosda infratuzilma loyihalarini amalga oshirishga xususiy investorlarni jalb qilish imkonini beradi. Tomonlarning har biri umumiy loyihaga hissa qo‘shadi, bu esa har ikki tomonning maqsadlariga eng samarali tarzda erishish imkonini beradi.',
    about4: "Resurs samaradorligi",
    about41:'Davlat-xususiy sheriklik zamonaviy ta\'limning turli ta\'lim ehtiyojlari bo\'lgan bolalarga ta\'lim berish kabi muammolarini hal qilish vositasi sifatida qaralishi mumkin; ta\'lim dasturlari sifatini oshirish uchun mablag\'larni birlashtirish va to\'plash.',
    about5: "Ko'p tomonlama yondashuv",
     about51:'DXSh loyihalarida ko\'p tomonlama yondashuv loyihani boshlashdan oldin uni har tomonlama tahlil qilish imkonini beradi va uni amalga oshirish jarayonida ko\'p qirrali bo\'lishini ta\'minlaydi.',
     about6: "Uzoq muddatli rivojlanish",
     about61:'DXSh loyihalari resurslarni ixtiyoriy ravishda birlashtirish va daromadlar yoki nomulkiy foyda, xarajatlar va xatarlarni taqsimlash asosida xalq ta\'limi sohasida uzoq muddatli investitsiya loyihalarini amalga oshirish maqsadida davlat va xususiy sektor o\'rtasidagi hamkorlikni nazarda tutadi. ',
     about0: 'PPP nima?'
}
